export default __webpack_public_path__ + "static/media/Tendencias.7b4e6eed.svg";